import { DrEntity } from './dr-entity';
import { DrObject, DrObjectType, SupportedRegExType } from './dr-object';

export class DomainListViewModel extends DrObject {
    model: Partial<DomainList>;
    constructor(value?: Partial<DomainList>) {
        super(DrObjectType.DOMAIN_LIST, SupportedRegExType.PATTERNS);
        if (value) {
            this.model = value;
        }
    }
}

export class DomainList extends DrEntity {
    name: string;
    description: string;
    createOn: string;
    createdBy: string;
    domainEntries: Array<any>;
    projectHandle: string;

    constructor(value?: Partial<DomainList>) {
        super(value);
        if (value) {
            Object.assign(this, value);
        }
    }
}
